import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TenderService } from 'src/app/core/services/tender.service';
import b64toBlob from "b64-to-blob";
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-online-tender-details',
  templateUrl: './online-tender-details.component.html',
  styleUrls: ['./online-tender-details.component.scss']
})
export class OnlineTenderDetailsComponent implements OnInit {
  tenderData: any = null; // Holds tender data
  noData: boolean = false; // Flag for missing data

  constructor(private service: PublicPortalService, private router: Router, private tenderService: TenderService) {}

  ngOnInit(): void {
    this.tenderData = this.tenderService.getTenderData();


    if (!this.tenderData) {
      this.noData = true;
    }
  }


  getAttachmentByGUID(Guid:any) {
    debugger

    let downloadFile: any = {};

    downloadFile.ID = Guid;


    this.service.FileByGuid(downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = baseResponse.data['bytes'];
        var ContentType = baseResponse.data['contentType'];
        var FileName = baseResponse.data['fileName'];

        const blob = b64toBlob(Bytes, ContentType);
        saveAs(blob, FileName);
      }
    });
  }

  goBack() {
    this.router.navigate(['/tender']); // Navigate back
  }
}
